import { gql } from '@apollo/client';

export const UPDATE_STUDY_STATUS = gql`
  mutation UpdateStudyStatus($id: ID!) {
    updateStudyStatus(id: $id) {
      project {
        id
        releasedAt
        studyStatus
      }
    }
  }
`;

export const REPROCESS_PROJECT_ELASTIC_SEARCH = gql`
  mutation ReprocessProjectElasticsearch($id: ID!) {
    reprocessProjectElasticsearch(id: $id) {
      void
    }
  }
`;

export const UPDATE_STUDY_STATUS_BY_COMPANY = gql`
  mutation UpdateStudyStatusByCompany($companyId: ID, $globalIds: [ID!], $attributes: ControlsAttributes!) {
    updateStudyStatusByCompany(companyId: $companyId, globalIds: $globalIds, attributes: $attributes) {
      company {
        id
      }
    }
  }
`;

export const UPDATE_RECORDER_TYPE = gql`
  mutation UpdateSegmentRecorderType($id: ID!, $recorderType: RecorderTypeEnum!) {
    updateSegmentRecorderType(id: $id, recorderType: $recorderType) {
      segment {
        id
        recorderType
      }
    }
  }
`;
